import PropTypes from 'prop-types';
import React from 'react';
import ReportBox from '../barbersReport/reportBox';

const TaxesCollected = ({ report, refundAmount }) => {
  const data = [{
    title: 'Taxes collected',
    amount: report.taxAmount,
  }, {
    title: 'Refunded',
    amount: refundAmount,
  }];

  const content = data.map((item, index) => (
    <ReportBox key={index} {...item} />
  ));

  return (
    <div className="layout u-mv-">{content}</div>
  );
};

TaxesCollected.propTypes = {
  report: PropTypes.object.isRequired,
  refundAmount: PropTypes.number.isRequired,
};

export default TaxesCollected;
